// extracted by mini-css-extract-plugin
export default {"infoContainer":"calculationConstructionDetailsNew_infoContainer__reyIZ","infoBox":"calculationConstructionDetailsNew_infoBox__4uyHQ"};